<template>
  <div class="award-record">
    <div class="main">
      <h2>获奖记录</h2>
      <ul id="list" v-if="list && list.length > 0">
        <li v-for="(item, index) in list" :key="index">
          <p>
            {{ item.title }}
            <em>{{ item.integral }}</em>
            <i v-if="item.next" @click="next(item.quota, item.url)">></i>
          </p>
          <span>{{ item.createTime }}</span>
        </li>
      </ul>
      <p v-else class="none">暂无数据~</p>
    </div>
    <div class="grant-box cash-grant" v-if="showGrant">
      <div class="grant">
        <img
          src="@/assets/img/grant_close.png"
          class="close"
          @click.stop="close"
        />
        <h2>奖励发放</h2>
        <h3>
          恭喜您! 抽中
          <span>{{ quota }}</span>
          元现金
        </h3>
        <p>
          请您凭借此二维码在微信福利群中
          <br />
          兑换现金奖励!
        </p>
        <div class="cash">
          <img :src="codeText" />
        </div>
        <button class="btn" @click.stop="save">保存二维码</button>
      </div>
    </div>
  </div>
</template>
<script>
import { integralRecord } from '@/api/activity'
export default {
  name: 'AwardRecord',
  data() {
    return {
      params: {
        pn: 1,
        ps: 20,
        flag: 2,
      },
      list: [],
      userCode: '',
      isLoading: true,
      showGrant: false,
      quota: '',
      codeText: '',
    }
  },
  mounted() {
    document.title = '获奖记录'
    this.userCode = this.$route.query.userCode
    this.init()
    this.scro11()
  },
  methods: {
    async init() {
      let res = await integralRecord(this.params)
      if (res.code == '1000' && res.data.length > 0) {
        this.list.push(...res.data)
        this.isLoading = true
        this.list.forEach((item) => {
          item.title = item.detailExplain.split(' ')[0]
          item.integral = item.detailExplain.split(' ')[1]
          if (item.integral.indexOf('现金') > -1) {
            item.next = true
          }
        })
      } else if (res.data.length <= 0) {
        this.isLoading = false //无数据可以加载
      }
    },
    //滚动分页加载数据
    scro11() {
      document.getElementsByClassName('main')[0].onscroll = async () => {
        //距离底部时加载一次
        let bottomofwindow =
          document.getElementsByClassName('main')[0].scrollTop +
            (window.innerHeight -
              document.getElementsByClassName('title')[0].offsetHeight) >=
          document.getElementsByClassName('main')[0].scrollHeight
        if (bottomofwindow && this.isLoading == true) {
          this.params.pn = this.params.pn + 1 //每次分页+1
          this.init()
        }
      }
    },
    next(quota, url) {
      this.codeText = url
      this.quota = quota
      this.showGrant = true
    },
    save() {
      const url = this.codeText
      window.location.href =
        'appdjxhealth://actionSavePicture?picUrl=' + url
      this.showGrant = false
    },
    close() {
      this.showGrant = false
    }
  },
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.award-record {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f2f5fa;
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: scroll;
    padding-top: 3.15vh;
    h2 {
      font-size: 4vw;
      text-align: center;
    }
    .none {
      margin: 30vh auto;
      font-size: 4vw;
      text-align: center;
    }
  }
  ul {
    width: 90.87vw;
    height: auto;
    background: #ffffff;
    border-radius: 1.82vw;
    margin: 2vw auto 6.9vh;
    padding-bottom: 2vh;
    li {
      width: 78.65vw;
      height: 9.75vh;
      padding-top: 2.25vh;
      border-bottom: 0.15vh solid #ededed;
      margin-left: 10.27vw;
      p {
        color: #333333;
        font-size: 3.8vw;
        em {
          color: #fb4933;
          margin-left: 3vw;
        }
        i {
          float: right;
          margin-right: 3vw;
          font-size: 4vw;
        }
        &::before {
          content: '';
          display: inline-block;
          vertical-align: middle;
          width: 2.08vw;
          height: 2.08vw;
          background: #22c089;
          border-radius: 100%;
          margin-left: -5vw;
          margin-right: 2vw;
        }
      }
      span {
        display: block;
        margin-top: 1.5vh;
        color: #999999;
        font-size: 3.12vw;
      }
    }
  }
  .grant-box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .grant {
      width: 68vw;
      background: linear-gradient(7deg, #fdf4d9, #ffffff);
      border: 0.26vw solid #ffffff;
      border-radius: 6.37vw;
      margin: 0 auto;
      height: auto;
      position: relative;
      .close {
        width: 4.94vw;
        height: 4.94vw;
        position: absolute;
        right: 0;
        top: -3.9vh;
      }
      h2 {
        width: 28vw;
        height: 3.7vh;
        background: linear-gradient(-34deg, #ffe391, #ffedb6);
        border-radius: 0px 0px 2.34vw 2.34vw;
        margin: -0.2vh auto;
        color: #872306;
        font-size: 3.77vw;
        text-align: center;
        line-height: 3.7vh;
      }
      h3 {
        text-align: center;
        font-family: zihunxingmouhei_trial;
        font-weight: 600;
        color: #872306;
        margin-top: 3vh;
        font-size: 4.42vw;
        span {
          color: #ff5958;
        }
      }
      p {
        font-family: PingFang SC;
        color: #872306;
        text-align: center;
        font-size: 2.99vw;
        margin: 1.425vh 0 2.925vh;
      }
      .btn {
        border: none;
        display: block;
        background: url('~@/assets/img/btn_bg.png') no-repeat;
        background-size: 100% 100%;
        width: 50.7vw;
        height: 8.325vh;
        font-weight: 600;
        color: #fffbf5;
        text-shadow: 0px 2px 0px rgba(10, 31, 62, 0.15);
        font-size: 5.72vw;
        margin: -3vh auto 4vh;
      }
      .hand {
        width: 13.26vw;
        height: 12.15vh;
        background: url('~@/assets/img/grant_hand.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 7.4vw;
        bottom: -4.35vh;
      }
      .cash {
        width: 25.22vw;
        height: 25.22vw;
        background: url('~@/assets/img/grant_code.png') no-repeat;
        background-size: 100% 100%;
        margin: 2.25vh auto 7vh;
        padding: 0.4vw;
        img {
          border-radius: 2vw;
          width: 100%;
        }
      }
    }
  }
  .cash-grant {
    background-image: url('~@/assets/img/grant_bg2.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 27vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/awardRecord.vue